export const Types = {
  Params: Symbol.for('Params'),
  Navigate: Symbol.for('Navigate'),
  Props: Symbol.for('Props'),
  SearchParams: Symbol.for('SearchParams'),
};
